function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var loaded = false;
function loadSDK(apiKey) {
    if (typeof window.Upscope !== "undefined") {
        loaded = true;
        return;
    }
    var i = function i1() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        i.q.push(args);
    };
    i.q = [];
    // The real Upscope implementation is loaded below
    window.Upscope = i;
    var s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = "https://code.upscope.io/".concat(apiKey, ".js");
    document.head.appendChild(s);
    loaded = true;
}
var _Upscope = function _Upscope() {
    for(var _len = arguments.length, instruction = new Array(_len), _key = 0; _key < _len; _key++){
        instruction[_key] = arguments[_key];
    }
    var _window;
    if (!loaded) {
        if (instruction[0] === "init") {
            var config = instruction[1];
            if (!(config === null || config === void 0 ? void 0 : config.apiKey)) {
                throw new Error("API key not specified");
            }
            loadSDK(config.apiKey);
        } else {
            throw new Error("Upscope is not loaded");
        }
    }
    return (_window = window).Upscope.apply(_window, _toConsumableArray(instruction));
};
export default _Upscope;


//# sourceMappingURL=sdk.js.map